<template>
    <EditModal
        id="mitgliederProbenbenefit"
        title="Probenvergütung"
        size="lg"
        button-text="Speichern"
        :busy="busy"
        :loading="isLoading"
        scrollable
        @ok="dataProvide"
        @hide="dataCancel"
    >
        <MitgliederProbenbenefit :id="id" @change="updateData" />
    </EditModal>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import MitgliederProbenbenefit from "@/components/MitgliederProbenbenefit/MitgliederProbenbenefit";
import EditModal from "@/components/EditModal/EditModal";
import Toaster from "@/mixins/Toaster/Toaster";

const ProbentypApi = ApiFactory.get("probentyp");

export default {
    name: "MitgliederProbenbenefitModal",
    components: {
        MitgliederProbenbenefit,
        EditModal
    },
    mixins: [Toaster],
    props: ["id"],
    data() {
        return {
            data: [],
            busy: false
        };
    },
    computed: {
        isLoading() {
            return this.data.length <= 0;
        }
    },
    methods: {
        async dataProvide(evt) {
            evt.preventDefault();
            this.busy = true;
            const response = await ProbentypApi.putBenefit(this.id, this.data);
            if (response.ok) {
                this.dataCancel();
                this.$root.$emit("bv::hide::modal", "mitgliederProbenbenefit");
                this.makeToast(
                    "Erfolgreich gespeichert",
                    "Die Änderungen wurden erfolgreich in der Datenbank gespeichert"
                );
            }
            this.busy = false;
        },
        dataCancel() {
            this.data = [];
        },
        updateData(data) {
            this.data = data;
        }
    }
};
</script>